// Save-intent (image intent) attribution derived from Redux state.
import { createSelector } from 'reselect';
import {
  ImageIntentGallery,
  imageIntentGalleryFromAdditionalData,
} from '../components/v3/shared/protectedImage/imageIntentGallery';

// The gallery the parent entered the current ordering flow with, as the
// explicit triple a save-intent context carries. useImageIntentFriction fills
// the same triple in by itself; this is for reports made outside the hook
// (native listeners on SweetAlert markup), which must name the gallery
// themselves or report none.
interface StateWithAdditionalData {
  additionalData?: Parameters<typeof imageIntentGalleryFromAdditionalData>[0];
}

export const selectImageIntentGallery = createSelector(
  (state: StateWithAdditionalData) => state.additionalData,
  (additionalData): ImageIntentGallery =>
    imageIntentGalleryFromAdditionalData(additionalData),
);
